<div class="container-fluid login-container">
    <div class="row">
        <div class="col-lg-6 h-100 d-none d-lg-block">
            <div class="login-container_content">
                <img src="../../../../assets/images/Logo.svg" alt="logo" class="img-fluid logo-img" />
                <div class="login-content">
                    <h2 class="login-title">Start your remarkable journey with us!</h2>
                    <p class="login-text">
                        Our cold email automation helps you send personalized cold
                        <br />
                        emails at scale with high email deliverability.
                    </p>
                </div>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="login-container_form">
                <h2 class="login-title">Password Changed</h2>
                <p class="login-text">
                    Your password has been changed successfully!
                </p>
                <form class="login-form">

                    <div class="form-group">
                        <button class="btn btn-primary w-100" type="button" [routerLink]="'/auth/login'">Back to Login</button>
                    </div>
                </form>

            </div>
        </div>
    </div>
</div>